import { render, staticRenderFns } from "./detailNav.vue?vue&type=template&id=62f51206&scoped=true"
import script from "./detailNav.vue?vue&type=script&lang=js"
export * from "./detailNav.vue?vue&type=script&lang=js"
import style0 from "./detailNav.vue?vue&type=style&index=0&id=62f51206&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62f51206",
  null
  
)

export default component.exports